import { render, staticRenderFns } from "./ClientOrderToolbar.vue?vue&type=template&id=4f71cdea&scoped=true&"
import script from "./ClientOrderToolbar.vue?vue&type=script&lang=js&"
export * from "./ClientOrderToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f71cdea",
  null
  
)

export default component.exports